import React from 'react';
import { toast } from 'react-toastify';
import { AlertTriangle, ShieldCheck, ShieldAlert } from 'lucide-react';

/**
 * Custom lockdown toast with critical priority styling
 */
export const lockdownToast = {
  engaged: () => {
    toast(
      <div className="toast-with-icon">
        <div className="toast-icon-wrapper critical">
          <ShieldAlert size={20} />
        </div>
        <div className="toast-content">
          <div className="toast-title">🚨 LOCKDOWN ENGAGED</div>
          <div className="toast-message">All doors have been locked</div>
        </div>
      </div>,
      {
        className: 'toast-lockdown',
        autoClose: 10000,
        closeOnClick: false,
        pauseOnHover: true,
      }
    );
  },

  released: () => {
    toast(
      <div className="toast-with-icon">
        <div className="toast-icon-wrapper success">
          <ShieldCheck size={20} />
        </div>
        <div className="toast-content">
          <div className="toast-title">Lockdown Released</div>
          <div className="toast-message">Normal door operations restored</div>
        </div>
      </div>,
      {
        className: 'Toastify__toast--success',
        autoClose: 5000,
      }
    );
  },

  error: (message) => {
    toast(
      <div className="toast-with-icon">
        <div className="toast-icon-wrapper critical">
          <AlertTriangle size={20} />
        </div>
        <div className="toast-content">
          <div className="toast-title">Lockdown Failed</div>
          <div className="toast-message">{message || 'Unable to execute lockdown'}</div>
        </div>
      </div>,
      {
        className: 'Toastify__toast--error',
        autoClose: 8000,
      }
    );
  },
};

export default lockdownToast;
